import {GenericZoneEditEngine} from './generic-zone-edit-engine.class';
// @ts-ignore
import * as mapboxgl from 'mapbox-gl';
import {Observable, of} from 'rxjs';
import {MapControlPanelAction} from './map-edit-engine.interface';
import {QGraph} from '../../interfaces/geo-and-movement.interfaces';

export class StartZoneEditEngine extends GenericZoneEditEngine {
  constructor(map: mapboxgl.Map,
              mapControlPanelAction$: Observable<MapControlPanelAction>,
              zone?: QGraph) {
    super(map, mapControlPanelAction$,'start-zones', 'start-zone-outline', false, undefined, zone);
    this.postInit();
  }

  getStrokeColor$(): Observable<string> {
    return of('#34C759');
  }

}
